/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetVideoFileTokenOptions, GetVideoFileTokenResponses } from '../../models/GetVideoFileToken'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get a video download token. This token is used to download document contents from the download video file route.
 * @summary Get Video File Download Token
 * {@link /video/:video_id/download-token}
 */
export function getVideoFileToken<ThrowOnError extends boolean = true>(options: Options<GetVideoFileTokenOptions, ThrowOnError>): Promise<UnwrappedResult<GetVideoFileTokenResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/video/{video_id}/download-token', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetVideoFileTokenResponses, ThrowOnError>>
}
